import { DS2 } from '../../theme/designTokens';

/**
 * DS2 filter pill — Figma HOME frame (134×44 r70 ×0.75): active = light
 * pill with dark text, inactive = gold pill at 0.4 opacity with white
 * text. Shared by Home's match filter and Friends' tab switcher.
 */
export function FilterPill({ label, active, onClick, badge, compact }: { label: string; active: boolean; onClick: () => void; badge?: number | null; compact?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        boxSizing:  'border-box',
        display:    'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap:        compact ? 6 : 7,
        minWidth:   compact ? 68 : 86,
        height:     compact ? 26 : 31,
        padding:    compact ? '0 13px' : '0 16px',
        borderRadius: 52.5,
        border:     'none',
        cursor:     'pointer',
        background: active ? '#D9D9D9' : '#C8A74C',
        opacity:    active ? 1 : 0.4,
        color:      active ? '#0B0B0B' : '#FFFFFF',
        fontFamily: DS2.font.body,
        fontWeight: 500,
        fontSize:   compact ? 13 : 16.6,
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      {label}
      {badge != null && badge > 0 && (
        <span
          style={{
            background: '#0B0B0B',
            color:      '#FFC844',
            fontSize:   compact ? 10 : 11.3,
            fontWeight: 700,
            minWidth:   compact ? 16 : 19,
            height:     compact ? 16 : 19,
            borderRadius: 10,
            display:    'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding:    '0 6px',
          }}
        >
          {badge > 9 ? '9+' : badge}
        </span>
      )}
    </button>
  );
}
